<fui-rows [formGroup]="editService.formGroup">
    <fui-row [label]="'wbo.account-type.edit.field-set.statementContent'">
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-text-edit-control formControlName="statementTitle"
                                           [(ngModel)]="model.data.statementTitle"></wbo-text-edit-control>
                    <wbo-text-edit-control formControlName="statementHeader"
                                           [(ngModel)]="model.data.statementHeader"></wbo-text-edit-control>
                    <wbo-statement-address-block-type-single-select-edit-control
                        formControlName="statementAddressBlockTypeDbValue"
                        [(ngModel)]="model.data.statementAddressBlockTypeDbValue"
                        [allowClearSelectionOption]="false"></wbo-statement-address-block-type-single-select-edit-control>
                    <wbo-checkbox-edit-control formControlName="useDefaultCompanyForStatements"
                                               [(ngModel)]="model.data.useDefaultCompanyForStatements"></wbo-checkbox-edit-control>
                </fui-column>
                <fui-column>
                    <ng-container formGroupName="logoImage">
                        <wbo-image-edit-control formControlName="image" [(ngModel)]="model.data.logoImage.image">
                        </wbo-image-edit-control>
                    </ng-container>
                    <wbo-textarea-edit-control formControlName="statementFooter"
                                               [(ngModel)]="model.data.statementFooter"></wbo-textarea-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
    </fui-row>
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <fui-inline-information [title]="'wbo.common.info.information'"
                                        [message]="'wbo.account-type.edit.message.invoiceContent'"></fui-inline-information>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row [label]="'wbo.account-type.edit.field-set.issuing'">
        <fui-row>
            <fui-column>
                <wbo-checkbox-edit-control formControlName="issueStatements"
                                           [(ngModel)]="model.data.issueStatements"></wbo-checkbox-edit-control>
            </fui-column>
        </fui-row>
        <ng-container *ngIf="model.data.issueStatements">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-single-select-edit-control formControlName="detailLevel"
                                                        [(ngModel)]="model.data.detailLevel"
                                                        [allowClearSelectionOption]="false">
                            <wbo-select-options>
                                <wbo-select-option [value]="'summary'"
                                                   label="wbo.account-type.edit.option.detailLevel.summary">
                                </wbo-select-option>
                                <wbo-select-option [value]="'detailed'"
                                                   label="wbo.account-type.edit.option.detailLevel.detailed">
                                </wbo-select-option>
                            </wbo-select-options>
                        </wbo-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <ng-container formGroupName="statementEmailSettings">
                            <wbo-email-setting-single-select-edit-control formControlName="emailSettingId"
                                                                          [(ngModel)]="model.data.statementEmailSettings.emailSettingId"
                                                                          [objectValue]="model.data.statementEmailSettings">
                            </wbo-email-setting-single-select-edit-control>
                        </ng-container>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="statementEmailFrom"
                                               [(ngModel)]="model.data.statementEmailFrom"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="statementEmailSubject"
                                               [(ngModel)]="model.data.statementEmailSubject"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-columns>
                    <fui-column>
                        <wbo-textarea-edit-control formControlName="statementEmailBody"
                                                   [(ngModel)]="model.data.statementEmailBody"></wbo-textarea-edit-control>
                    </fui-column>
                </fui-columns>
            </fui-row>
        </ng-container>
        <fui-row>
            <fui-column>
                <wbo-checkbox-edit-control formControlName="issueInvoices"
                                           [(ngModel)]="model.data.issueInvoices"></wbo-checkbox-edit-control>
            </fui-column>
        </fui-row>
        <ng-container *ngIf="model.data.issueInvoices">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <ng-container formGroupName="invoiceEmailSettings">
                            <wbo-email-setting-single-select-edit-control formControlName="emailSettingId"
                                                                          [(ngModel)]="model.data.invoiceEmailSettings.emailSettingId"
                                                                          [objectValue]="model.data.invoiceEmailSettings">
                            </wbo-email-setting-single-select-edit-control>
                        </ng-container>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="invoiceEmailFrom"
                                               [(ngModel)]="model.data.invoiceEmailFrom"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="invoiceEmailSubject"
                                               [(ngModel)]="model.data.invoiceEmailSubject"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-columns>
                    <fui-column>
                        <wbo-textarea-edit-control formControlName="invoiceEmailBody"
                                                   [(ngModel)]="model.data.invoiceEmailBody"></wbo-textarea-edit-control>
                    </fui-column>
                </fui-columns>
            </fui-row>
        </ng-container>
    </fui-row>
</fui-rows>
